export default (context, inject) => {
  // 取得三個 plugin 的方法
  // infobip: this.$infobipTrackEvent, gtag: this.$gaLogEvent, urec: this.$urec.sendEventLog

  /**
   * @description GA 分析事件 上報
   * @param {string} eventName 事件名稱
   * @param {Object} params 參數物件
   */
  const reportGA = (eventName, eventParams) => {
    console.log('ga event:', eventName, eventParams, context.app, context.app.$gaLogEvent)
    if (typeof context.app.$gaLogEvent === 'function') {
      context.app.$gaLogEvent(eventName, eventParams)
    }
  }

  /**
  * @description Infobip 上報
  * @param {string} eventName 事件名稱
  * @param {any} eventParams 參數
  */
  const reportInfobip = (eventName, eventParams) => {
    console.log('infobip event:', eventName, eventParams, context.app, context.app.$infobipTrackEvent)
    if (typeof context.app.$infobipTrackEvent === 'function') {
      context.app.$infobipTrackEvent(eventName, eventParams)
    }
  }

  /**
   * @description UREC 上報
   * @param {Array} events 事件陣列
   */
  const reportUREC = (events) => {
    console.log('UREC event:', events, context.app, context.app.$urec)
    if (context.app.$urec && typeof context.app.$urec.postUrecEventLog === 'function') {
      context.app.$urec.postUrecEventLog(events)
    }
  }

  /**
   * @description 一鍵上報
   * @param {string} eventName 事件名稱
   * @param {Object} eventParams 參數物件
   */
  const reportAll = (eventName, eventParams) => {
    reportGA(eventName, eventParams)
    reportInfobip(eventName, eventParams)
    reportUREC([{ event_name: eventName, event_params: eventParams }])
  }

  // 注入 $eventHub
  inject('eventHub', {
    reportGA,
    reportInfobip,
    reportUREC,
    reportAll
  })
}
